type FileType = 'document' | 'media' | 'image'

/**
 * Returns a string representing the type of file
 */
export function categorizeFileType(fileMimeType: string): FileType {
  const mediaTypes: string[] = ['audio', 'video']
  const imageTypes: string[] = ['image']

  const lowerMimeType: string = fileMimeType.toLowerCase()

  if (mediaTypes.some((mediaType) => lowerMimeType.includes(mediaType))) {
    return 'media'
  } else if (
    imageTypes.some((imageType) => lowerMimeType.includes(imageType))
  ) {
    return 'image'
  } else {
    return 'document'
  }
}

/**
 * Truncates the filename to the specified length
 */
export function truncateFileName(fileName: string, maxLength: number): string {
  if (!fileName) {
    return fileName
  }

  const splittedFileName = fileName.split('.')
  if (splittedFileName.length > 1) {
    const extension = splittedFileName[splittedFileName.length - 1]

    if (fileName.length - extension.length > maxLength) {
      return `${fileName
        .replace(extension, '')
        .substring(0, maxLength - 1)
        .concat('...')}.${extension}`
    }
  }

  return fileName
}

/**
 * Returns a string representing the size of the file in readable format
 */
export function formatFileSize(size: number) {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
  return (
    Number((size / Math.pow(1024, i)).toFixed(2)) * 1 +
    ' ' +
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  )
}

/**
 * Returns a Base64 image
 */
export const getBase64Image = async (
  file: File,
): Promise<string | undefined> => {
  return new Promise<string | undefined>((resolve) => {
    const reader = new FileReader()
    try {
      reader.readAsDataURL(file)
      reader.onload = function () {
        resolve(reader.result ? reader.result.toString() : undefined)
      }
      reader.onerror = function (_) {
        resolve(undefined)
      }
    } catch (e) {
      resolve(undefined)
    }
  })
}
